export { BaseNode, type BaseNodeProps } from './BaseNode'
export { IncomingCallNode } from './IncomingCallNode'
export { AIAgentNode } from './AIAgentNode'
export { OperatorNode } from './OperatorNode'
export { VoicemailNode } from './VoicemailNode'
export { PlayMessageNode } from './PlayMessageNode'
export { TimeCheckNode } from './TimeCheckNode'
export { HangupNode } from './HangupNode'

import { IncomingCallNode } from './IncomingCallNode'
import { AIAgentNode } from './AIAgentNode'
import { OperatorNode } from './OperatorNode'
import { VoicemailNode } from './VoicemailNode'
import { PlayMessageNode } from './PlayMessageNode'
import { TimeCheckNode } from './TimeCheckNode'
import { HangupNode } from './HangupNode'

// React Flow expects ComponentType<NodeProps> but we use simpler props
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const nodeTypes: Record<string, React.ComponentType<any>> = {
  incoming_call: IncomingCallNode,
  ai_agent: AIAgentNode,
  operator: OperatorNode,
  voicemail: VoicemailNode,
  play_message: PlayMessageNode,
  time_check: TimeCheckNode,
  hangup: HangupNode,
}
